import {Formik} from 'formik'
import {Button, Col, Form, FormControl, Row} from 'react-bootstrap'
import React, {useEffect} from 'react'
import * as Yup from 'yup'
import {withStore} from '@bigyellow/store'
import {email_verify_code} from '@bigyellow/api/register'
import {handle_api_exception} from '@bigyellow/api/exception'
import {update_user} from '@bigyellow/api/customer'
import useResendCooldown from '@bigyellow/libs/useResendCooldown'

const VerifyEmailCode = ({store ,email , inDebugCode ='', currentPassword,onSendEmailVerificationCode,isEmailUpdate =false,userId=0 ,   OnSuccess,OnCancel, isDisabled=false, description='We have sent a verification code to your email address. Please enter the code below.'}) => {
  const schema = Yup.object().shape({
    code: Yup.string().required('This field is required')
  });
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [code, setCode] = React.useState(inDebugCode);

  const RESEND_COOLDOWN_SECONDS = 60;
  const { secondsLeft: resendSecondsLeft, isCoolingDown, start: startResendCooldown } = useResendCooldown(RESEND_COOLDOWN_SECONDS);

  useEffect(() => {
    if(inDebugCode && inDebugCode !== "")
      setCode(inDebugCode);
  }, [inDebugCode]);

  // Start cooldown immediately since  we've already sent a code.
  useEffect(() => {
    startResendCooldown(RESEND_COOLDOWN_SECONDS);
  }, [startResendCooldown]);

  const onClickResend = async (e) => {
    // Prevent form submit / navigation on link button.
    if (e && typeof e.preventDefault === 'function') e.preventDefault();

    // Safety: ignore if cooldown active, or external disables.
    if (isCoolingDown || isSubmitting || isDisabled) return;

    // Lock out immediately.
    startResendCooldown(RESEND_COOLDOWN_SECONDS);

    try {
      if (typeof onSendEmailVerificationCode === 'function') {
        await onSendEmailVerificationCode();
      }
    } catch (error) {
      // Keep cooldown even on failure (prevents rapid retry). Still show the error.
      const notify = store.get('notify');
      notify(handle_api_exception(error), {type: 'error'});
    }
  };

  const onSubmitForm = ({code}) => {
    setCode(code);
    setIsSubmitting(true);
    (async () => {
      try {
        const http_client = store.get('http_client');
        if(isEmailUpdate)
        {
          let payload = { email: email , code: code, id: userId }
          if(currentPassword && currentPassword !== "")
            payload.current_password = currentPassword;

          await update_user(http_client, payload);

        }else {
            await email_verify_code(http_client, {email: email, code: code});
        }

          OnSuccess();
      } catch (error) {
        const notify = store.get('notify');
        notify(handle_api_exception(error), {type: 'error'});
      }
      finally {
        setIsSubmitting(false);
      }
    })();

  }


  return <Formik
    enableReinitialize
    validationSchema={schema}
    onSubmit={onSubmitForm}
    initialValues={{code: code}}
  >
    {({
        handleChange,
      handleSubmit,
        values,
        touched,
        errors,
      }) => (
      <Form
        noValidate
        onSubmit={handleSubmit}
        id="verifyCodeForm"
        autoComplete="off"
      >
        <React.Fragment>
          {OnCancel &&
          <i
            className={`lni lni-close icon close`}
            onClick={OnCancel}
          />
          }
          {description && description!=="" &&
          <Row className={"mb-4"}>
            <Col>
              <p>
                {description}
              </p>
            </Col>
          </Row>
          }
          <Form.Row>
            <Form.Group
              as={Col}
              controlId="validationPhone"
              className="material material label-top mb-4"
            >
              <FormControl
                type="text"
                name="code"
                value={values.code}
                onChange={handleChange}
                isInvalid={
                  touched.code && errors.code
                }
              />
              <Form.Label column={false}>Verification code</Form.Label>
              <Form.Control.Feedback type="invalid">
                {errors.code}
              </Form.Control.Feedback>
            </Form.Group>
          </Form.Row>
          <Row className={"my-1"}>
            <Col className={`text-center`}>
              <div>
                <Button
                    type="submit"
                    variant="primary"
                    className={'btn-wide'}
                    disabled={isSubmitting || isDisabled}
                >
                  Validate
                </Button>
              </div>
              <div className={'mt-3 text-sm'}>
                Didn't receive a code?
                <Button
                        variant="link"
                        size='sm'
                        className={'ps-0 pe-0'}
                        style={{ width: 'unset' }}
                        onClick={onClickResend}
                        disabled={isSubmitting || isDisabled || isCoolingDown}
                        aria-disabled={isSubmitting || isDisabled || isCoolingDown}
                >
                  {isCoolingDown ? `Resend in ${resendSecondsLeft}s` : 'Resend code'}
                </Button>
              </div>

            </Col>
          </Row>
        </React.Fragment>
      </Form>
    )}
  </Formik>

}

export default withStore(VerifyEmailCode);
